import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import TaxRateItemContainer from './TaxRateItemContainer';
import { TableMarginTop } from 'components/list/TableComponentsStyled';
import { RoundedHeaderTableRow, ThemedHeaderTableCell } from 'components/common/table/TableStyles';
import WrappedFakeText from 'components/common/WrappedFakeText';

const TaxRateList = ({ list, loading, onCancelNew }) => {
  const [t] = useTranslation();

  return (
    <TableMarginTop sx={{ tableLayout: 'fixed' }}>
      <TableHead>
        <RoundedHeaderTableRow>
          <ThemedHeaderTableCell>{t('TaxRate.Description')}</ThemedHeaderTableCell>
          <ThemedHeaderTableCell>{t('TaxRate.Code')}</ThemedHeaderTableCell>
          <ThemedHeaderTableCell>{t('TaxRate.Type')}</ThemedHeaderTableCell>
          <ThemedHeaderTableCell>{t('TaxRate.Percent')}</ThemedHeaderTableCell>
          <ThemedHeaderTableCell width='120px' align='right'>
            {t('Actions')}
          </ThemedHeaderTableCell>
        </RoundedHeaderTableRow>
      </TableHead>
      <TableBody>
        {loading && (
          <TableRow>
            <TableCell colSpan={5} sx={{ px: 0.5 }}>
              <WrappedFakeText />
            </TableCell>
          </TableRow>
        )}
        {!loading && list.map((item, index) => <TaxRateItemContainer key={item.id} item={item} index={index} onCancelNew={onCancelNew} />)}
      </TableBody>
    </TableMarginTop>
  );
};

TaxRateList.propTypes = {
  list: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  onCancelNew: PropTypes.func.isRequired
};

export default TaxRateList;
